// Secciones del Mapa de Oportunidades
// Los section_title deben coincidir con OPP_QUESTIONS del backend oportunidades_service.py
export const OPP_SECTIONS = [
  { id: 'tendencias_entorno', title: 'Tendencias del entorno' },
  { id: 'necesidades_no_cubiertas', title: 'Necesidades no cubiertas' },
  { id: 'analisis_competitivo', title: 'Análisis competitivo' },
  { id: 'brechas_mercado', title: 'Brechas del mercado' },
  { id: 'recursos_capacidades', title: 'Recursos y capacidades' },
  { id: 'evaluacion_viabilidad', title: 'Evaluación de viabilidad' },
  { id: 'priorizacion', title: 'Priorización de oportunidades' },
  { id: 'plan_captura', title: 'Plan de captura' },
];

// Bloques con respuesta predefinida (sin consumo de IA).
// Deben coincidir con _PREDEFINED_OPP_BLOCKS del backend oportunidades_service.py
export const PREDEFINED_OPP_SECTIONS = new Set([
  'Tendencias del entorno',
  'Análisis competitivo',
  'Brechas del mercado',
  'Recursos y capacidades',
  'Evaluación de viabilidad',
  'Priorización de oportunidades',
]);
